import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

const ThankYou = ({ email }: any) => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/auth/login");
  };

  return (
    <div className="main-wrapper authendication-pages">
      <div className="content">
        <div className="container wrapper no-padding">
          <div className="row no-margin vph-100">

            <div className="col-12 col-sm-12  col-lg-4 no-padding">
              <div className="dull-pg">
                <div className="row no-margin vph-100 d-flex align-items-top justify-content-center">
                  <div className="col-sm-10 col-md-10 col-lg-10 mx-auto">
                    <div className="shadow-card thankyou">
                      <h2 className="text-center">Thank you!</h2>
                      <p className="text-center">Your referral details have been successfully submitted. We appreciate your effort in helping us grow our team! </p>
                        <div className="tab-content" id="myTabContent">
                        <div
                          className="tab-pane fade show active"
                          id="user"
                          role="tabpanel"
                          aria-labelledby="user-tab"
                        >
                          <form>
                            <button
                              type="submit"
                              onClick={handleLoginClick}
                              className="btn btn-secondary register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block">
                              Close
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-lg-8 no-padding">
              <div className="banner-bg login">
              <div className="row no-margin h100">
                    <div className="col-sm-10 col-md-10 col-lg-12">
                        <div className="row  h-100">
                          <div className="col-md-6 h50">
                            <img src="/assets/img/authOne.png" className="img-fluid w-100 h-100" alt="authOne"/>
                          </div>
                          <div className="col-md-6  h50">
                            <img src="/assets/img/authTwo.png" className="img-fluid  w-100 h-100" alt="authTwo"/>
                          </div>
                          <div className="col-md-6  h50">
                            <img src="/assets/img/authThree.png" className="img-fluid w-100 h-100" alt="authOne"/>
                          </div>
                          <div className="col-md-6  h50">
                            <img src="/assets/img/authFour.png" className="img-fluid  w-100 h-100" alt="authTwo"/>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default ThankYou